<template>
    <div class="content">
        <van-form @submit="onSubmit">
            <van-field v-model="form.college_name" label="学校名称" placeholder="请填写" :rules="[{ required: true, message: '请填写学校名称！' }]"/>
            <div class="major" style="position: relative;">
                <van-field v-model="major" label="专业名称" placeholder="请填写" @input="getMajor" :rules="[{ required: true, message: '请填写专业名称！' }]"/>
                <!-- <van-field v-model="major" label="专业名称" placeholder="请填写" :rules="[{ required: true, message: '请填写专业名称！' }]" @blur="blurMajor"/> -->
                <div class="major_content" style="position: absolute;" v-show="isMajor && major">
                    <span v-for="(v,i) in majorArr" :key="i" @click="checkMajor(v)">{{v.text}}</span>
                </div>
            </div>
            <div class="education plc plcgo">
                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="form.education_id"
                    label="最高学历"
                    placeholder="请选择"
                    @click="eduPicker = true"
                    :rules="[{ required: true, message: '请选择学历！' }]"
                />
                <van-popup v-model="eduPicker" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="eduColumns"
                        @confirm="eduConfirm"
                        @cancel="eduPicker = false"
                    />
                </van-popup>
                <img :src="require('@/assets/img/go.png')" alt="">
            </div>
            <div class="way plc plcgo">
                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="form.education_way_id"
                    label="方式"
                    placeholder="请选择"
                    @click="wayPicker = true"
                    :rules="[{ required: true, message: '请选择教育途径！' }]"
                />
                <van-popup v-model="wayPicker" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="waycolumns"
                        @confirm="wayConfirm"
                        @cancel="wayPicker = false"
                    />
                </van-popup>
                <img :src="require('@/assets/img/go.png')" alt="">
            </div>
            <div class="way plc plcgo">
                <van-field
                    readonly
                    clickable
                    label="时间段"
                    :value="form.date"
                    placeholder="选择时间段"
                    @click="timePicker = true"
                    :rules="[{ required: true, message: '请选择时间段！' }]"/>
                <van-popup v-model="timePicker" position="bottom">
                    <time-date
                        show-toolbar
                        v-model="currentDate"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @cancel="timePicker = false"
                        @confirm="timeConfirm"
                    >
                    </time-date>
                </van-popup>
                <img :src="require('@/assets/img/go.png')" alt="">
            </div>
            <div style="margin: 16px">
                <van-button round block type="danger" native-type="submit">下一步</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import { getWayApi,getEducationApi,getMajorApi,editEduExpApi,getEduExpById } from "@/api/interview";
import TimeDate from '@/components/TimeDate'
import { Toast } from 'vant';
var time = new Date();
var cyear = time.getFullYear();
var cmonth = time.getMonth();
var cday = time.getDate()
    export default {
        data(){
            return {
                form:{},
                subForm:{},
                eduColumns:[], //学历
                eduPicker:false,
                waycolumns:[], //教育途径
                wayPicker:false,
                timePicker:false, //时间选择器
                minDate: new Date(1900, 5, 15),
                maxDate: new Date(cyear+4, 11, 30),
                currentDate: new Date(),
                startDate: '',
                endDate: '',
                major:"",
                way:{},
                education:{},
                majorArr:[],
                isMajor:false,
                id:sessionStorage.getItem("ID") || 0
            }
        },
        mounted(){
            console.log('this.$route.info')
            // console.log(this.$route.query,'this.$route.query')
            // if(this.$route.query.info){
            //     var info = JSON.parse(this.$route.query.info)
            //     console.log(info,'info')
            // }

        },

        methods:{
            onSubmit(){
                // 下方时间+字符串'-01'是用来方便后端数据处理
                if(this.subForm.start_date){
                    this.subForm.start_date = this.subForm.start_date+'-01'
                    this.subForm.end_date = this.subForm.end_date+'-01'
                }
                const params = {
                    resume_id:this.id,
                    ...this.form,
                    ...this.subForm,
                    major_name:this.major,
                    id: this.$route.query.id
                }
                editEduExpApi(params).then(res=>{
                    if(res.errNo===0){
                        this.$router.push({path:"educationlist",query:{edit:this.$route.query.edit}})
                    } else {
                        Toast('提交失败,请检查填写信息');
                    }
                })
            },
            // 学历选择器
            eduConfirm(value){
                this.form.education_id  = value.text
                this.subForm.education_id = value.id
                this.eduPicker = false
            },
            // 教育途径选择器
            wayConfirm(value){
                this.form.education_way_id  = value.text
                this.subForm.education_way_id = value.id
                this.wayPicker = false
            },
            // 时间段选择器
            timeConfirm(value, index) {
                this.startDate = value.slice(0,2).join('-');
                this.endDate = value.slice(3,6).join('-');
                this.form.date = this.startDate + '-' + this.endDate;
                this.subForm.start_date=this.startDate
                this.subForm.end_date=this.endDate
                this.timePicker = false
            },
            // 选择专业
            checkMajor(v){
                this.major = v.text
                this.subForm.major_id = v.id
                this.isMajor = false
            },
            blurMajor(){
                this.isMajor = false
            },
            // 模糊查询专业
            getMajor(newVal){
                const params = {
                    title:newVal
                }
                getMajorApi(params).then(res=>{
                    if(res.errNo===0){
                        this.majorArr=[]
                        if(res.result.length < 1){
                            this.majorArr = []
                            this.isMajor = false
                            return
                        }
                        for(let key in res.result){
                            // if(res.result[key]===newVal){
                            //     this.majorArr=[]
                            //     return;
                            // }
                            this.majorArr.push({
                                id:key,
                                text:res.result[key]
                            })
                        }
                        this.isMajor = true
                    }
                })
            },
            // 页面初始化获取数据
            async getData(params){
                let temform = {
                    ...params
                }
                // 获取教育途径
                await getWayApi().then(res=>{
                    if(res.errNo===0){
                        this.way = res.result
                        for(let key in this.way){
                            this.waycolumns.push({
                                id:key,
                                text:res.result[key]
                            })
                        }
                    }
                })
                // 获取学历
                await getEducationApi().then(res=>{
                    if(res.errNo===0){
                        this.education = res.result
                        temform.education=res.result[temform.education]
                        for(let key in res.result){
                            this.eduColumns.push({
                                id:key,
                                text:res.result[key]
                            })
                        }
                    }
                })

                // 信息回显
                await getEduExpById({id: this.$route.query.id}).then(res=>{
                    if(res.errNo===0){
                        // 回显处理
                        // subForm 这个对象是用来传给后端的，包括选择的id
                        // form 这个对象是用来回显文字的，并不传给后端，只做显示
                        // 拿到数据后，先把各个ID添加到 subForm 对象中 ， 再把form中的各个id更换成对应文字用于回显，因为上面绑定的是各个id，如不这么处理，回显的也就是相应的数字id
                        // 我能力有限，只能这么处理
                        this.form.college_name = res.result.college_name
                        this.subForm.major_id = res.result.major_id
                        this.major = res.result.major_name
                        this.subForm.education_id = res.result.education_id
                        this.form.education_id  = res.result.education_name
                        this.subForm.education_way_id = res.result.education_way_id
                        this.form.education_way_id  = res.result.education_way_name
                        if(res.result.start_date && res.result.end_date){
                            this.form.date = res.result.start_date + '-' + res.result.end_date;
                            this.subForm.start_date=res.result.start_date
                            this.subForm.end_date=res.result.end_date
                        }
                        console.log(this.subForm.education_id,'this.subForm.education_id')
                    }
                })
            }
        },
        created(){
            let params = this.$route.query
            this.getData(params)
        },
        mounted() {
            // if(this.$route.query.edit){
            //     this.$refs['savebtn'].innerHTML="保存"
            // }
        },
        // watch:{
        //     major(newVal,oldVal){
        //         this.getMajor(newVal)
        //     }
        // },
        components:{
            TimeDate
        }
    }
</script>

<style scoped lang="less">
/deep/ .van-cell {
  display: block;
}
/deep/ .van-field__error-message {
  text-align: center;
}
/deep/ .van-cell::after {
  border-bottom: 1px solid #999999;
}
.plc {
    position: relative;
    &::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 30px;
    bottom: 0;
    left: 30px;
    border-bottom: 1px solid #999999;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

.plcgo {
    img {
        width: 18px;
        height: 31px;
        position: absolute;
        right: 30px;
        top: 54px;
    }
}
/deep/ .van-image{
    width: 100px;
    height: 100px;
    img{
        border-radius: 50%;
    }
}
/deep/ .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
/deep/ .van-button--block {
  border-radius: 10px;
}

.major_content{
    z-index: 9999;
    width: 400px;
    padding: 0 20px;
    margin: 0 auto;
    height: 300px;
    overflow: hidden;
    overflow-y: scroll;
    background: #ffffff;
    &::-webkit-scrollbar {
        width: 6px;
    }
    span {
        font-size: 26px;
        display: block;
        padding: 10px 30px;
    }
}
</style>
